module.exports = __webpack_public_path__ + "static/media/ug_logo.549e957b.png";